<template>
    <div class="relative w-full max-w-xl mx-auto">
        <div class="mb-6">
            <input
                class="mt-3 appearance-none block w-full bg-white text-gray-700 border border-gray-200 rounded-md py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                type="tel"
                id="leadPhone"
                v-model="leadPhone">
        </div>

        <div class="flex flex-col sm:flex-row justify-center space-y-3 sm:space-y-0 sm:space-x-3">
            <button class="text-center w-full sm:w-auto inline-flex items-center justify-center rounded-full focus:outline-none focus:ring-0 transition py-4 px-6 text-sm sm:text-lg font-medium whitespace-nowrap border bg-brand-lime text-brand-teal border-transparent hover:bg-brand-lime hover:ring-1 hover:ring-offset-1 ring-offset-transparent ring-brand-lime"
                type="submit"
                @click="updateAndCall">
                <span>Yes, call again</span>
            </button>

            <button class="text-center w-full sm:w-auto inline-flex items-center justify-center rounded-full focus:outline-none focus:ring-0 transition py-4 px-6 text-sm sm:text-lg font-medium whitespace-nowrap border bg-brand-teal-light text-white border-transparent hover:bg-brand-teal-light hover:ring-1 hover:ring-offset-1 ring-offset-transparent ring-brand-teal-light"
                type="submit"
                @click="updateAndSchedule"
                v-if="hasCalendly">
                <span>Schedule appointment</span>
            </button>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        data() {
            return {
                leadPhone: this.$store.getters.leadPhone
            }
        },

        computed: {
            ...mapGetters([
                'hasCalendly',
                'leadHash'
            ])
        },

        methods: {
            async update() {
                const payload = {
                    phone: this.leadPhone
                };

                try {
                    const {data} = await this.$http.put(route('api.lead.update', this.leadHash), payload);
                    this.$store.commit('leadPhone', data.phone);
                } catch (error) {

                    // Show error modal to user
                    this.$store.commit('modal', 'call-error');
                }
            },

            updateAndCall() {
                this.update();

                this.$event.$emit('retry-call');
            },

            updateAndSchedule() {
                this.update();

                this.$store.commit('modal', 'schedule-appointment');
            }
        },
    }
</script>
